import InboxAdmin from "../Components/InboxAdmin/InboxAdmin"
const AdminInbox = () => {
  return (
        <InboxAdmin/>
  )
}

export default AdminInbox